// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__26Sx-","unreadBadge":"styles_unreadBadge__tEDhl","modalContent":"styles_modalContent__1l19V","modal":"styles_modal__1tyd8"};